export default __webpack_public_path__ + "static/media/tacy_mobile.a49cd697.jpg";